<div>
    <div class="row pb-2">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary" (click)="add(0)"
                [disabled]="isDisabled">
                <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Shift Group':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            <div class="row">
                <div class="col">
                    Shift Group Master
                </div>
                <div class="col-auto">
                    <div class="col-auto">
                        <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary me-2" name="sample"
                            (click)="exportToExcel()">
                            <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Excel':'Loading...'}}
                        </button>
                        <!-- <button *ngIf="this.common.PageRight.IsAdd" class="btn btn-sm btn-outline-primary me-2"
                            name="sample" (click)="downloadExcel()">
                            <i class="bi bi-file-earmark-spreadsheet" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Sample':'Loading...'}}
                        </button>
                        <button *ngIf="this.common.PageRight.IsAdd" class="btn btn-sm btn-success me-2" name="sample"
                            (click)="this.upload()">
                            <i class="bi bi-upload" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Upload':'Loading...'}}
                        </button> -->
                        <!-- <label *ngIf="this.common.PageRight.IsAdd" for="file-upload" class="btn btn-sm btn-primary">
                        <i class="bi bi-cloud-upload-fill" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled ? 'Excel Upload' : 'Loading...'}}
                    </label>
                    <input id="file-upload" type="file" style="display: none" (change)="handleFileInput($event)"
                        accept=".xls,.xlsx"> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered pt-2">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                        <th>Shift Group Name</th>

                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let element of Shift">
                        <td style="width: 5px;">
                            <div class="text-center" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}"><i
                                    (click)="add(element['ESS_ShiftGroupMasterID'])"
                                    class="bi bi-pencil-square text-warning"></i></div>
                        </td>
                        <td> {{element['ShiftGroupName']}}</td>

                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>